import React, { useEffect, useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const sectionRef = useRef(null);
  const autoplayRef = useRef(null);
  const testimonials = [{
    quote: 'Niqqanno helped us restructure and secure investor funding we thought was impossible.',
    name: 'A.O.',
    title: 'CEO, Tech Startup',
    image: 'https://i.pinimg.com/736x/7e/83/0e/7e830e9c49dee63d546ba2b376523d30.jpg'
  }, {
    quote: "Their legal expertise and business insight is unmatched. They don't just advise, they position you for growth.",
    name: 'B.M.',
    title: 'Founder, FMCG Company',
    image: 'https://i.pinimg.com/1200x/1b/e5/7e/1be57e732a85c0d9ea96c92f3a4b64e1.jpg'
  }, {
    quote: 'With Niqqanno, compliance stopped feeling like a burden and became part of our growth strategy.',
    name: 'T.M.',
    title: 'COO, Fintech Firm',
    image: 'https://i.pinimg.com/736x/a7/78/1b/a7781b8c72004ae4f9c014cfeeffd005.jpg'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
  };
  const handleTouchStart = e => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      nextSlide();
    }
    if (touchStart - touchEnd < -50) {
      prevSlide();
    }
  };
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('opacity-100');
        entry.target.classList.remove('opacity-0', 'translate-y-10');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  useEffect(() => {
    autoplayRef.current = setTimeout(() => {
      nextSlide();
    }, 6000);
    return () => {
      if (autoplayRef.current) {
        clearTimeout(autoplayRef.current);
      }
    };
  }, [currentSlide]);
  return <section className="py-20 bg-primary-dark text-white" data-id="element-258">
      <div className="container mx-auto px-4" data-id="element-259">
        <div ref={sectionRef} className="text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 opacity-0 translate-y-10" data-id="element-260">
          <h2 className="text-white font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-261">
            Client Testimonials
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-8" data-id="element-262"></div>
          <p className="text-gray-300" data-id="element-263">
            Hear from our clients about their experience working with Niqqanno
            Consulting.
          </p>
        </div>
        <div className="relative max-w-4xl mx-auto" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-264">
          <div className="overflow-hidden" data-id="element-265">
            <div className="flex transition-transform duration-700 ease-in-out" style={{
            transform: `translateX(-${currentSlide * 100}%)`
          }} data-id="element-266">
              {testimonials.map((testimonial, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-267">
                  <div className="bg-primary p-8 md:p-12 rounded-lg shadow-xl" data-id="element-268">
                    <div className="flex flex-col md:flex-row items-center" data-id="element-269">
                      <div className="w-24 h-24 rounded-full overflow-hidden mb-6 md:mb-0 md:mr-8 flex-shrink-0 border-2 border-gold" data-id="element-270">
                        <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-271" />
                      </div>
                      <div data-id="element-272">
                        <blockquote className="text-lg md:text-xl italic mb-6" data-id="element-273">
                          "{testimonial.quote}"
                        </blockquote>
                        <div data-id="element-274">
                          <p className="text-gold font-bold" data-id="element-275">
                            {testimonial.name}
                          </p>
                          <p className="text-gray-300" data-id="element-276">{testimonial.title}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Navigation Buttons */}
          <button className="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-6 bg-gold text-primary-dark rounded-full p-2 focus:outline-none hidden md:block" onClick={prevSlide} data-id="element-277">
            <ChevronLeft size={24} data-id="element-278" />
          </button>
          <button className="absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-6 bg-gold text-primary-dark rounded-full p-2 focus:outline-none hidden md:block" onClick={nextSlide} data-id="element-279">
            <ChevronRight size={24} data-id="element-280" />
          </button>
          {/* Indicators */}
          <div className="flex justify-center mt-8 space-x-2" data-id="element-281">
            {testimonials.map((_, index) => <button key={index} className={`w-3 h-3 rounded-full focus:outline-none ${currentSlide === index ? 'bg-gold' : 'bg-gray-500'}`} onClick={() => setCurrentSlide(index)} data-id="element-282" />)}
          </div>
        </div>
      </div>
    </section>;
};